export const CARS_BOOKED_STATE_ASSIGNED = 'assigned'
export const CARS_BOOKED_STATE_NOT_ASSIGNED = 'not-assigned'
export const CARS_BOOKED_STATE_PENDING = 'pending'
